<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.caen_code, 'Cod CAEN')"
      v-model="caenCode"
      :rules="caenCodeValidationRules"
      name="caen_code"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null | number,
  },
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const caenCode = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      caenCode.value = newValue;
    });

    watch(caenCode, (newValue) => {
      error.value = '';
      const isValid = validateCaenCode(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      emit('validation-customer-status', { field: 'caen_code', isValid });
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const caenCodeValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
    ];

    function validateCaenCode(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = caenCodeValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return caenCodeValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateCaenCode(caenCode.value);
      emit('validation-customer-status', { field: `caen_code`, isValid });

      // Listen for validate event
      window.addEventListener('validate-customer', (data) => {
        if (data.detail && data.detail === 'caen_code') {
          const isValid = validateCaenCode(caenCode.value, true);
          if (isValid) {
            emit('validation-customer-status', { field: 'caen_code', isValid });
          }
        }
      });
    });

    return {
      caenCode,
      caenCodeValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>
